import React from 'react'
import Laptop from '../assets/laptop.jpg'
import Okay from '../assets/okay_.jpg'
import { Link } from 'react-router-dom';


const Analytics = () => {
  return (
    <div className='w-full bg-white py-16 px-4'>
        <div className='max-w-[1240px] mx-auto grid md:grid-cols-2'>
            <img className='w-[400px] mx-auto my-4 rounded-md' src={Okay} alt='/'/>
            <div className='flex flex-col justify-center'>
                <p className='text-black font-bold'>IT'S OKAY KOK !</p>
                <h1 className='md:text-4xl sm:text-3xl text-2xl font-bold py-2'>Enggak Ada Salahnya Mengeluh Terhadap Sesuatu</h1>
                <p>Semua orang pasti tertimpa yang namanya cobaan hidup, dan itu tugas kita untuk melalui semua hal itu, dan menjadikan kita Seseorang yang lebih kuat. Yang penting jangan banding-bandingkan masalah mu dengan masalah orang lain yaa !</p>
                <Link to={`register`}>
                <button className='text-[#00df9a] w-[200px] rounded-md font-medium my-6 mx-auto md:mx-0 py-3 bg-black'>Yuk Daftar</button>
                </Link>
            </div>
        </div>

    </div>
  )
}

export default Analytics